// extracted by css-extract-rspack-plugin
export default {"pageContainer":"Lnv8fXVcEQdQW_w2__pageContainer___"};